import React from 'react'

const Serverless = () => {
  return (
    <>
      Serverless page
    </>
  )
}

export default Serverless
